import { get, post } from '../../../../api/index';
export const toMessageList = params => get(`/api/notification/v1/list`, params); // 通知列表
export const toMessageRead = params => post(`/api/notification/v1/read`, params); // 通知阅读
